import type { ReactElement } from "react"
import { useState } from "react"
import React from "react"
import ImageWithTextLinkAtm from "@onestore/hel/dist/components/atoms/ImageWithTextLinkAtm"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import OverlayContainerOrg, {
  sizes,
  startPositions,
} from "@onestore/hel/dist/components/organisms/OverlayContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import ResponsiveMedia from "@gatsby-plugin-generic-page/components/ResponsiveMedia"
import { stripMarkdownText } from "@gatsby-plugin-generic-page/helpers/stripMarkdownText"
import type { PacketSpecialDiscountDrawerType } from "~/fragments/packetSpecialDiscountDrawer"
import assetsSquidexToImageObject from "~/lib/assetsSquidexToImageObject"
import isEmpty from "~/lib/isEmpty"

const PacketSpecialDiscountDrawer = ({
  buttonText,
  buttonIcon,
  modalTitle,
  modalImages,
  modalContent,
}: PacketSpecialDiscountDrawerType): ReactElement<PacketSpecialDiscountDrawerType> => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const handleButtonClick = () => {
    setIsDrawerOpen((isOpen) => !isOpen)
  }

  const handleCloseButtonClick = () => {
    setIsDrawerOpen(false)
  }

  return (
    <>
      <ImageWithTextLinkAtm
        image={assetsSquidexToImageObject(buttonIcon, "")}
        text={
          <MarkdownText
            typography={{ default: "xsmall1", bold: "xsmall2" }}
            pushSpace={0}
          >
            {buttonText}
          </MarkdownText>
        }
        link={{
          onClick: handleButtonClick,
          title: stripMarkdownText(buttonText),
        }}
        paddingSpace={1}
        hasArrow
        hasBorder
      />

      {isDrawerOpen ? (
        <OverlayContainerOrg
          hasSections
          header={<TextAtm typography="large2">{modalTitle}</TextAtm>}
          onCloseButtonClick={handleCloseButtonClick}
          startPosition={startPositions.RIGHT}
          size={sizes.MEDIUM}
        >
          <PushOrg
            leftSpace={{ small: 2, medium: 0, large: 0 }}
            rightSpace={{ small: 2, medium: 0, large: 0 }}
            hasNoReset
          >
            {!isEmpty(modalImages) ? (
              <AlignContentOrg horizontalAlign="center">
                <PushOrg bottomSpace={4} hasNoReset>
                  <ResponsiveMedia media={modalImages} />
                </PushOrg>
              </AlignContentOrg>
            ) : null}

            <MarkdownText
              typography={{ default: "medium1_h", bold: "medium3_h" }}
            >
              {modalContent}
            </MarkdownText>
          </PushOrg>
        </OverlayContainerOrg>
      ) : null}
    </>
  )
}

export default PacketSpecialDiscountDrawer
